import React from 'react';
import { GenericModal, ParetoLogo, MainTheme } from '@paretogroup/tess';

import { CloseIconWrapper } from '@shared/components/modals/FullScreenModal';
import { CloseWorkflowModalIcon } from '@shared/components/icons/svgs';
import { NO_TRANSLATE_CLASSNAME } from '@shared/components/no-translate/translation.constants';
import { IMAGES, TEXTS } from '@domain/integrations/integrations.constants';
import * as S from './modal-strategy.styles';

import { ModalProps } from './modal-strategy.types';

type Props = ModalProps & {
    isOpen: boolean
    onClose: () => void
}

const getComponent = (component, defaultComponent, children) => {
    const Component = component || defaultComponent;
    return props => <Component {...props}>{ children }</Component>;
};

export const ModalComponent = ({
    title,
    titleComponent,
    subtitle,
    subtitleComponent,
    body: Content,
    isOpen,
    onClose,
}: Props) => {
    const classes = S.useStyles();
    const ModalTitle = getComponent(titleComponent, S.TitleWrapper, title);
    const ModalSubtitle = getComponent(subtitleComponent, S.Paragraph, subtitle);
    return (
        <GenericModal
            logo={(
                <ParetoLogo
                    colors={{ fill: MainTheme.colors.white }}
                />
            )}
            headerButton={(
                <CloseIconWrapper
                    onClick={onClose}
                    data-testid="close-icon"
                >
                    <CloseWorkflowModalIcon
                        backgroundColor={MainTheme.colors.white}
                        height={36}
                        width={36}
                    />
                </CloseIconWrapper>
            )}
            title={(
                <S.TitleWrapper>
                    <ModalTitle class={NO_TRANSLATE_CLASSNAME} />
                    {TEXTS.FINAL_TITLE}
                </S.TitleWrapper>
            )}
            subtitle={(<ModalSubtitle />)}
            backgroundImage={IMAGES.MODAL_BACKGROUND.SRC}
            open={isOpen}
            onClose={onClose}
            classes={classes}
        >
            <Content />
        </GenericModal>
    );
};
